import {
  ColumnBlockSchema,
  ColumnsBlockSchema,
} from '@blocksuite/affine-model';
import {
  BlockPlainTextAdapterExtension,
  type BlockPlainTextAdapterMatcher,
} from '@blocksuite/affine-shared/adapters';

const passThroughMatcher = (flavour: string): BlockPlainTextAdapterMatcher => ({
  flavour,
  toMatch: () => false,
  fromMatch: o => o.node.flavour === flavour,
  toBlockSnapshot: {},
  fromBlockSnapshot: {},
});

export const ColumnsBlockPlainTextAdapterExtension =
  BlockPlainTextAdapterExtension(
    passThroughMatcher(ColumnsBlockSchema.model.flavour)
  );

export const ColumnBlockPlainTextAdapterExtension =
  BlockPlainTextAdapterExtension(
    passThroughMatcher(ColumnBlockSchema.model.flavour)
  );
